import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IndustryService } from '../services/industry.service'

import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-industry',
    templateUrl: './industry.component.html',
    animations: [fadeInUp]
})
export class IndustryPageComponent implements OnInit, OnDestroy {

    // Template Variables
    industrySlug: any = ''
    industries: any
    industry: any
    careers: any
    paramsChangeSubsciption: any
    currentParam: string;
    industrySubscription: any
    
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private industryService: IndustryService,
        private title: Title
    ) { 
        this.paramsChangeSubsciption = this.route.params.subscribe(params => {
            if (params.industry !== this.currentParam) {
                if (this.industrySlug) {
                    this.loadIndustry()
                }
            }
        })
    }

    ngOnInit() {
        this.loadIndustry()
    }

    loadIndustry() {
        this.industrySlug = this.route.snapshot.params['industry'];
        this.currentParam = this.industrySlug

        this.industryService.getIndustries()
        this.industrySubscription = this.industryService.Industries.subscribe(industries => {
            if (industries && industries.length > 0) {
                this.industries = industries
                this.industry = this.industries.filter(elm => elm.slug === this.industrySlug)[0]
                this.getCareers()
                this.updateTitle()
            }
        })
    }

    updateTitle() {
        const title = this.industry.name + ' | ' + 'Industry'
        if (this.industrySlug) {
            this.title.setTitle(title)
        }
    }

    ngOnDestroy() {
        if (this.paramsChangeSubsciption) {
            this.paramsChangeSubsciption.unsubscribe()
        }
        if (this.industrySubscription) {
            this.industrySubscription.unsubscribe()
        }
    }

    getCareers() {
        this.industryService.getCareersByIndustryId(this.industry['_id']).subscribe(careers => {
            this.careers = careers.json()
            this.sortCareers()
        }, err => {
            console.log(err);
        })
    }

    sortCareers() {
        this.careers.sort((a, b) => {
            let returnVal = 0
            if (a.name < b.name) returnVal = -1;
            if (a.name > b.name) returnVal = 1;
            return returnVal;
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/industries/industry.component.ts